export default {
  STATE_FILTERS: {
    NY: {
      key: 'state',
      value: 'NY',
      label: 'New York'
    },
    NJ: {
      key: 'state',
      value: 'NJ',
      label: 'New Jersey'
    },
    FL: {
      key: 'state',
      value: 'FL',
      label: 'Florida'
    },
    AL: {
      key: 'state',
      value: 'AL',
      label: 'Alabama'
    },
    AK: {
      key: 'state',
      value: 'AK',
      label: 'Alaska'
    },
    CA: {
      key: 'state',
      value: 'CA',
      label: 'California'
    },
    CO: {
      key: 'state',
      value: 'CO',
      label: 'Colorado'
    },
    CT: {
      key: 'state',
      value: 'CT',
      label: 'Connecticut'
    },
    DE: {
      key: 'state',
      value: 'DE',
      label: 'Delaware'
    },
    GA: {
      key: 'state',
      value: 'GA',
      label: 'Georgia'
    },
    HI: {
      key: 'state',
      value: 'HI',
      label: 'Hawaii'
    },
    ID: {
      key: 'state',
      value: 'ID',
      label: 'Idaho'
    },
    IL: {
      key: 'state',
      value: 'IL',
      label: 'Illinois'
    },
    IN: {
      key: 'state',
      value: 'IN',
      label: 'Indiana'
    },
    IA: {
      key: 'state',
      value: 'IA',
      label: 'Iowa'
    },
    KS: {
      key: 'state',
      value: 'KS',
      label: 'Kansas'
    },
    KY: {
      key: 'state',
      value: 'KY',
      label: 'Kentucky'
    },
    AZ: {
      key: 'state',
      value: 'AZ',
      label: 'Arizona'
    },
    LA: {
      key: 'state',
      value: 'LA',
      label: 'Louisiana'
    },
    ME: {
      key: 'state',
      value: 'ME',
      label: 'Maine'
    },
    MD: {
      key: 'state',
      value: 'MD',
      label: 'Maryland'
    },
    MA: {
      key: 'state',
      value: 'MA',
      label: 'Massachusetts'
    },
    MI: {
      key: 'state',
      value: 'MI',
      label: 'Michigan'
    },
    MN: {
      key: 'state',
      value: 'MN',
      label: 'Minnesota'
    },
    MS: {
      key: 'state',
      value: 'MS',
      label: 'Mississippi'
    },
    MO: {
      key: 'state',
      value: 'MO',
      label: 'Missouri'
    },
    MT: {
      key: 'state',
      value: 'MT',
      label: 'Montana'
    },
    NE: {
      key: 'state',
      value: 'NE',
      label: 'Nebraska'
    },
    NV: {
      key: 'state',
      value: 'NV',
      label: 'Nevada'
    },
    NH: {
      key: 'state',
      value: 'NH',
      label: 'New Hampshire'
    },
    NM: {
      key: 'state',
      value: 'NM',
      label: 'New Mexico'
    },
    NC: {
      key: 'state',
      value: 'NC',
      label: 'North Carolina'
    },
    ND: {
      key: 'state',
      value: 'ND',
      label: 'North Dakota'
    },
    OH: {
      key: 'state',
      value: 'OH',
      label: 'Ohio'
    },
    OK: {
      key: 'state',
      value: 'OK',
      label: 'Oklahoma'
    },
    OR: {
      key: 'state',
      value: 'OR',
      label: 'Oregon'
    },
    PA: {
      key: 'state',
      value: 'PA',
      label: 'Pennsylvania'
    },
    RI: {
      key: 'state',
      value: 'RI',
      label: 'Rhode Island'
    },
    SC: {
      key: 'state',
      value: 'SC',
      label: 'South Carolina'
    },
    SD: {
      key: 'state',
      value: 'SD',
      label: 'South Dakota'
    },
    TN: {
      key: 'state',
      value: 'TN',
      label: 'Tennessee'
    },
    TX: {
      key: 'state',
      value: 'TX',
      label: 'Texas'
    },
    UT: {
      key: 'state',
      value: 'UT',
      label: 'Utah'
    },
    VT: {
      key: 'state',
      value: 'VT',
      label: 'Vermont'
    },
    VA: {
      key: 'state',
      value: 'VA',
      label: 'Virginia'
    },
    WA: {
      key: 'state',
      value: 'WA',
      label: 'Washington'
    },
    WV: {
      key: 'state',
      value: 'WV',
      label: 'West Virginia'
    },
    WI: {
      key: 'state',
      value: 'WI',
      label: 'Wisconsin'
    },
    WY: {
      key: 'state',
      value: 'WY',
      label: 'Wyoming'
    }
  }
};



// WEBPACK FOOTER //
// ./src/constants/LocationsMapFilters.js